import {Button} from '@/components/button';
import {DataTable} from '@/components/table/datatable';
import {
    XMarkIcon,
} from '@heroicons/react/24/outline';
import {
    CheckIcon,
    PaperAirplaneIcon
} from '@heroicons/react/24/solid';
import {ColumnDef} from '@tanstack/react-table';
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {AppDispatch} from "@/root/store";
import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import {ShowEvent} from "@/services/events";
import {
    DeleteAnnouncement,
    GetAnnouncement,
    GetAnnouncementRecipient, SendAnnouncement, ShowAnnouncement,
    StoreAnnouncement
} from "@/services/announcements";
import {DashboardCard} from "@/routes/org/dashboard/_card";
import {FormatCurrency} from "@/routes/root";

interface Outbox {
    id: number;
    name: string;
    email: string;
    sent: boolean;
}

export function OrgEventAnnouncementRecipient() {
    const location = useLocation();
    const navigate = useNavigate();
    const {slug, uuid} = useParams();
    const dispatch: AppDispatch = useDispatch();
    const [page, setPage] = useState(1);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({});

    const {
        recipients,
        announcement,
        announcementDeleted,
        paginator,
        errors
    } = useSelector((state: any) => state.announcements);
    const {event} = useSelector((state: any) => state.event);

    const queryParams = new URLSearchParams(location.search);
    const searchQuery: string = queryParams.get('search') ?? '';

    useEffect(() => {
        if (announcement.id) {
            setShowModal(false)
        }

        dispatch(GetAnnouncementRecipient(slug, uuid, searchQuery, page))
    }, [searchQuery, page, announcement, announcementDeleted]);

    useEffect(() => {
        dispatch(ShowEvent(slug))
        dispatch(ShowAnnouncement(slug, uuid))
    }, [slug, uuid]);

    const sendAnnouncement = () => {
        dispatch(SendAnnouncement(event.id, announcement.id))
    }

    const ctaButton = announcement.state === "in_process" ? <Button onClick={() => {
        sendAnnouncement()
    }} rightIcon={<PaperAirplaneIcon/>}>Kirim pengumuman</Button> : <></>;

    const columns: ColumnDef<Outbox>[] = [
        {
            header: 'Nama',
            cell: ({row}) => {
                const subject = row.original.name;
                return (
                    <div>
                        <p>{subject}</p>
                    </div>
                );
            },
        },
        {
            header: 'Email',
            accessorKey: 'email',
        },
        {
            header: 'Terkirim',
            cell: ({row}) => {
                const sent = row.original.sent;
                return (
                    <div>
                        {sent ? <CheckIcon className='h-6 w-6 text-green-500' /> : <XMarkIcon className='h-6 w-6 text-red-500' />}
                    </div>
                );
            },
        },
    ];

    return (
        <>
            <div className='grid grid-cols-2 gap-2 pb-2 sm:gap-6 md:grid-cols-3 xl:grid-cols-4'>
                <DashboardCard
                    variant='yellow'
                    name='Total penerima'
                    topLabel={{ primary: announcement?.number_recipients, secondary: 'penerima' }}
                />
                <DashboardCard
                    variant='blue'
                    name='Total email terkirim'
                    topLabel={{ primary: announcement?.number_emails_processed, secondary: 'email' }}
                />
            </div>

            <div className={'flex flex-col gap-2'}>
                <div>
                    <h1 className={'font-semibold'}>Subject</h1>
                    <span>{announcement.subject}</span>
                </div>

                <div className={'mb-3'}>
                    <h1 className={'font-semibold'}>Isi Email</h1>
                    <span>{announcement.body}</span>
                </div>
            </div>

            <DataTable
                name='Daftar penerima'
                ctaButton={ctaButton}
                columns={columns}
                data={recipients}
                total={paginator.to}
                currentTotal={paginator.total}
                currentPage={paginator.current_page}
                pages={paginator.last_page}
                onPageRequest={(nextPage) => setPage(nextPage)}
            />
        </>
    );
}
